import { FunctionComponent } from 'react'
import clsx from 'clsx'
import { Box, Button, ClassNameMap } from '@mui/material'
import { Translation } from '@dxp-module/common'
import { MyAccountButtonSubmitClasses } from '@dxp-module/themes'
import buttonSubmitStyles from './buttonSubmit.styles'

export type ButtonSubmitClasses = Partial<
  ClassNameMap<MyAccountButtonSubmitClasses>
>

type ButtonSubmitProps = {
  disabled: boolean
  classes?: ButtonSubmitClasses
}

const ButtonSubmit: FunctionComponent<ButtonSubmitProps> = ({
  disabled,
  classes,
}) => {
  const styles = buttonSubmitStyles()

  return (
    <Box
      className={clsx([
        styles.submitButtonContainer,
        classes?.submitButtonContainer,
      ])}
    >
      <Button
        type="submit"
        disabled={disabled}
        className={clsx([styles.submitButton, classes?.submitButton])}
        classes={{
          contained: clsx([styles.btnContained, classes?.btnContained]),
        }}
        variant="contained"
        color="primary"
        data-test="button:signup_form:submit"
      >
        <Translation id="trans__myaccount__create_an_account__submit_cta" />
      </Button>
    </Box>
  )
}

export default ButtonSubmit
